import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IClinicGroup, ICreateClinicGroupPayload, IUpdateClinicGroupPayload, IAssignClinicPayload } from '../models/clinic-group.model';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class ClinicGroupService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/clinic-groups';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) {}

  getGroups(): Observable<IClinicGroup[]> {
    return this.http.get<IClinicGroup[]>(this.baseUrl).pipe(
      catchError(this.handleError)
    );
  }

  getGroupById(id: string): Observable<IClinicGroup> {
    return this.http.get<IClinicGroup>(`${this.baseUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  createGroup(payload: ICreateClinicGroupPayload): Observable<IClinicGroup> {
    return this.http.post<IClinicGroup>(this.baseUrl, payload).pipe(
      catchError(this.handleError)
    );
  }

  updateGroup(id: string, payload: IUpdateClinicGroupPayload): Observable<IClinicGroup> {
    return this.http.put<IClinicGroup>(`${this.baseUrl}/${id}`, payload).pipe(
      catchError(this.handleError)
    );
  }

  deleteGroup(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`).pipe(
      catchError(this.handleError)
    );
  }

  assignClinic(groupId: string, payload: IAssignClinicPayload): Observable<IClinicGroup> {
    return this.http.post<IClinicGroup>(`${this.baseUrl}/${groupId}/clinics`, payload).pipe(
      catchError(this.handleError)
    );
  }

  removeClinic(groupId: string, cnpj: string): Observable<IClinicGroup> {
    return this.http.delete<IClinicGroup>(`${this.baseUrl}/${groupId}/clinics/${cnpj}`).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ocorreu um erro desconhecido.';

    if (error.status === 0) {
      errorMessage = 'Não foi possível conectar ao servidor.';
    } else if (error.error?.message) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Erro ${error.status}: ${error.statusText}`;
    }

    console.error('[ClinicGroupService]', errorMessage, error);
    return throwError(() => ({ status: error.status, message: errorMessage }));
  }
}
